module.exports = __webpack_public_path__ + "eugine.1a3c25ce8cd128d22d79.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/employees/eugine.png
// module id = ../../../../../src/assets/employees/eugine.png
// module chunks = 0